import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AddOrderTransmissionService} from 'src/app/raintree/transmission/order-transmission/order-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {OrderDetails} from '../interface/order-details';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Injectable({
	providedIn: 'root'
})
export class OrderService {

	constructor(
		private _orderTransmission: AddOrderTransmissionService,
		private _route: Router,
		public _toast: ToastMessageService,
		private _dialogRef: MatDialog
	) { }


	public cancelOrder(id: number, cancellationReason: string) {


		this._orderTransmission.cancelOrderRequest(
			RequestMapperService.CANCEL_ORDER,
			{
				orderId: id,
				cancellationReason: cancellationReason
			},
			(): void => {

			},
			(): void => {
			},
			(response: RaintreeResponse) => {
				this._toast.success('your order has been cancelled', 'your order has been cancelled');
				this._route.navigate(['profile/order']).then(() => {
					this._dialogRef.closeAll();
				});
			},
			(): void => {
			},
			(): void => {
			}
		)
	}


}
